import React from "react";
import { FiUsers, FiCode, FiPhoneCall } from "react-icons/fi";
import { PiUserFocus } from "react-icons/pi";
import { Link } from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";

const ServiceList = [
  {
    icon: <FiUsers />,
    title: "Client-centric Approach",
    description:
      "Experience a personalized and client-focused approach where your success is our priority. We become invested in your business, offering honest feedback and dedicated support.",
  },
  {
    icon: <FiCode />,
    title: "Tailored Solutions",
    description:
      "Benefit from customized software solutions that align perfectly with your business goals. We strive to meet your unique requirements effectively, ensuring a perfect fit for your needs.",
  },
  {
    icon: <FiPhoneCall />,
    title: "Transparent Communication",
    description:
      "Expect clear and open communication throughout our partnership. We keep you informed every step of the way, ensuring that your vision is understood and realized with precision.",
  },
];

const ServiceOne = ({ textAlign, serviceStyle }) => {
  return (
    <div className="row row--15 service-wrapper">
      {ServiceList.map((val, i) => (
        <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
          <ScrollAnimation
            animateIn="fadeInUp"
            animateOut="fadeInOut"
            animateOnce={true}
          >
            <div className={`service ${serviceStyle} ${textAlign}`}>
              <div className="icon">{val.icon}</div>
              <div className="content">
                <h4 className="title w-600">{val.title}</h4>
                <p className="description b1 color-gray mb--0">
                  {val.description}
                </p>
              </div>
            </div>
          </ScrollAnimation>
        </div>
      ))}
    </div>
  );
};
export default ServiceOne;
